// Vendor Libs
import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Button as ButtonPrime} from 'primereact/button';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';

// Components
import {Card} from 'primereact/card';
import 'primeflex/primeflex.css';

// Styles
import './shell-form.scss';

function ShellCredits({ formValues, setFieldValue }) {
  const [credits, setCredits] = useState([]);
  const [editCredits, setEditCredits] = useState(null);
  const [showCredits, setShowCredits] = useState(false);
  const [selectedCredit, setSelectedCredit] = useState(null);
  const container = useRef(null);

  useEffect(() => {
    if (formValues?.credits?.length) {
      setCredits(formValues?.credits);
    } else {
      setCredits([]);
    }
  }, [formValues]);

  const scrollIntoCard = () => setTimeout(() => {
      if (container.current) {
        container.current.scrollIntoView();
        document.getElementById('creditsCardFirstName').focus();
      }
    }, 220);

  const addCredits = () => {
    const creditsObject = {
      creditType: '',
      firstName: '',
      fullCreditName: '',
      lastNamesingleNameorgName: '',
      orgId: '',
      partName: '',
      sequenceNumber: !credits.length ? 0 : credits.length,
      echostarPersonId: '',
    };
    setShowCredits(true);
    setEditCredits(creditsObject);
    scrollIntoCard();
  };

  const setCreditsValue = (value, name) => {
    const creditsTemp = { ...editCredits };
    creditsTemp[name] = value;
    setEditCredits(creditsTemp);
  };

  const creditsInput = (caption, name, index, value, id = `${caption}-${name}`) => (
        <>
            <span className="p-float-label shell-form--addCreditsLabel" key={index}>
                {caption}
            </span>
            <InputText
                className="p-float-label shell-form--addCreditsInput"
                id={id}
                value={value}
                onChange={(e) => setCreditsValue(e.target.value, name)}
            />
            {(!value || !value.length) && (name === 'firstName' || name === 'lastNamesingleNameorgName') ? (
                <small className="p-error p-d-block" id={`${caption}-${name}`}>
                    This value must not be empty.
                </small>
            ) : null}
        </>
  );

  const deleteCreditsCard = (index) => {
    const tempCredits = JSON.parse(JSON.stringify(credits));
    tempCredits.splice(index, 1);
    tempCredits.forEach((c, index) => {
      c.sequenceNumber = index;
    });
    setCredits(tempCredits);
    setSelectedCredit(null);
    setEditCredits(null);
    setFieldValue('credits', tempCredits);
  };

  const creditsHeader = (index) => (
        <div className="p-grid p-align-center">
            <div className="p-col-5 p-col-align-start">
                <div className="p-button-danger">
                    <ButtonPrime
                        className="p-button-text p-red-text"
                        icon="pi pi-trash"
                        tooltip="Click to Remove"
                        onClick={() => deleteCreditsCard(index)}
                    />
                </div>
            </div>
            <div className="p-col p-col-align-center">
                <span className="shell-form--addCreditsHeader">{`Credits ${index + 1}`}</span>
            </div>
            <div className="p-col-1 p-col-align-end">
                <ButtonPrime
                    className="p-button-info p-button-text"
                    icon="pi pi-times"
                    tooltip="Click to Close/Cancel"
                    onClick={() => {
                      setSelectedCredit(null);
                      setEditCredits(null);
                    }}
                />
            </div>
        </div>
  );

  const creditsFooter = () => {
    const { firstName, lastNamesingleNameorgName } = editCredits;
    return (
            <div className="p-button-danger shell-form--creditsFooterDiv">
                <ButtonPrime
                    className="p-button-danger shell-form--addCreditsButton"
                    label="Cancel"
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      setSelectedCredit(null);
                      setEditCredits(null);
                    }}
                />
                <ButtonPrime
                    className="p-button-info shell-form--addCreditsButton"
                    disabled={
                        !firstName
                        || !firstName.length
                        || !lastNamesingleNameorgName
                        || !lastNamesingleNameorgName.length
                    }
                    label="Save"
                    onClick={() => {
                      const tempCredits = JSON.parse(JSON.stringify(credits));
                      if (!selectedCredit || !Object.keys(selectedCredit).length) {
                        tempCredits.push(editCredits);
                      } else {
                        tempCredits.forEach((t) => {
                          if (t.sequenceNumber === editCredits.sequenceNumber) {
                            for (const [key, value] of Object.entries(editCredits)) {
                              t[key] = value;
                            }
                          }
                        });
                      }
                      setCredits(tempCredits);
                      setSelectedCredit(null);
                      setEditCredits(null);
                      setFieldValue('credits', tempCredits);
                    }}
                />
            </div>
    );
  };

  const addCreditsButton = () => (
        <ButtonPrime
            className="p-button-outlined shell-form--addCreditsHeaderShow"
            label="Add Credits"
            onClick={addCredits}
        />
  );

  const showHideCredits = () => (
        <>
            <ButtonPrime
                className="p-button-text shell-form--addCreditsHeaderShow"
                icon={showCredits ? 'pi pi-minus' : 'pi pi-plus'}
                label={showCredits ? 'Hide Credits' : 'Show Credits'}
                onClick={() => {
                  setShowCredits(!showCredits);
                  setSelectedCredit(null);
                }}
            />
            <div className="p-button-text shell-form--addCreditsHeaderBottomDiv" />
        </>
  );

  const onCreditsRowReorder = (data) => {
    const { dragIndex, dropIndex } = data;
    const tempCredits = JSON.parse(JSON.stringify(credits));
    tempCredits.splice(dropIndex, 0, tempCredits.splice(dragIndex, 1)[0]);
    tempCredits.forEach((c, index) => {
      c.sequenceNumber = index;
    });
    setCredits(tempCredits);
    setFieldValue('credits', tempCredits);
  };

  const onCreditsRowSelect = (data) => {
    setSelectedCredit(data?.value);
    setEditCredits(data?.value);
    scrollIntoCard();
  };

    const renderCreditsCard = () => {
        const {
            sequenceNumber,
            firstName,
            lastNamesingleNameorgName,
            fullCreditName,
            creditType,
            partName,
        } = editCredits;
        return (
            <div ref={container}>
                <Card
                    className="shell-form--crewCard"
                    footer={creditsFooter(sequenceNumber)}
                    header={creditsHeader(sequenceNumber)}
                    id="creditsCard"
                >
                    {creditsInput('First Name', 'firstName', sequenceNumber, firstName, 'creditsCardFirstName')}
                    {creditsInput(
                      'Last Name/Single Name/Org Name',
                      'lastNamesingleNameorgName',
                      sequenceNumber,
                      lastNamesingleNameorgName
                    )}
                    {creditsInput('Full Credit Name', 'fullCreditName', sequenceNumber, fullCreditName)}
                    {creditsInput('Credit Type', 'creditType', sequenceNumber, creditType)}
                    {creditsInput('Part Name', 'partName', sequenceNumber, partName)}
                </Card>
            </div>
    );
  };

  const renderCredits = () => (
        <>
            <div className="p-button-danger shell-form--creditsInitDiv">
                {showHideCredits()}
                {showCredits ? addCreditsButton() : null}
            </div>
            {showCredits && credits && credits.length ? (
                <div className="card">
                    <DataTable
                        paginator={true}
                        reorderableRows={true}
                        reorderableColumns={true}
                        filterDisplay="row"
                        filter={false}
                        showFilterMenu={false}
                        rows={10}
                        selection={selectedCredit}
                        selectionMode="single"
                        sortMode="multiple"
                        stripedRows={true}
                        value={credits}
                        onRowReorder={onCreditsRowReorder}
                        onSelectionChange={onCreditsRowSelect}
                    >
                        <Column rowReorder={true} style={{ width: 20 }} />
                        <Column
                            field="firstName"
                            filter={true}
                            filterMatchMode="contains"
                            filterPlaceholder="Search"
                            header="First Name"
                            sortable={true}
                        />
                        <Column
                            field="lastNamesingleNameorgName"
                            filter={true}
                            filterMatchMode="contains"
                            filterPlaceholder="Search"
                            header="Last Name"
                            sortable={true}
                        />
                        <Column
                            field="fullCreditName"
                            filter={true}
                            filterMatchMode="contains"
                            filterPlaceholder="Search"
                            header="Credit Name"
                            sortable={true}
                        />
                        <Column
                            field="creditType"
                            filter={true}
                            filterMatchMode="contains"
                            filterPlaceholder="Search"
                            header="Credit Type"
                            sortable={true}
                        />
                        <Column
                            field="partName"
                            filter={true}
                            filterMatchMode="contains"
                            filterPlaceholder="Search"
                            header="Part Name"
                            sortable={true}
                        />
                    </DataTable>
                </div>
            ) : (
                <>
                    {showCredits && (
                        <div className="p-grid p-align-center">
                            <div className="p-col">
                                <div className="p-text-center p-text-light">Credits absent. Add at least one.</div>
                            </div>
                        </div>
                    )}
                </>
            )}
            {(selectedCredit || editCredits) && showCredits ? renderCreditsCard() : null}
        </>
  );

  return <>{renderCredits()}</>;
}

ShellCredits.propTypes = {
    formValues: PropTypes.object.isRequired,
    setFieldValue: PropTypes.func,
};

export default ShellCredits;
